import angular from 'angular';
import SaveProfilerToContact from './saveProfilerToContact';

export default angular
  .module('components.saveProfilerToContact', [])
  .component('saveProfilerToContact', SaveProfilerToContact).name;
